import { users as usersServices } from '@coligo-org/fe-common/services';
import logger from '../../../common/services/logService';
import { ErrorsActions } from '../error';
import { questionBankTypes } from '../../reducers/types';

export const getCourseTemplatesStart = () => ({
  type: questionBankTypes.GET_COURSE_TEMPLATES_START,
});

export const getCourseTemplatesEnd = () => ({
  type: questionBankTypes.GET_COURSE_TEMPLATES_END,
});

export default ({ principalId, requestParams, callback }) =>
  async dispatch => {
    try {
      dispatch(getCourseTemplatesStart());
      const { data } = await usersServices.getPrincipalCourseTemplates({
        principalId,
        params: requestParams,
      });
      if (callback) callback(data);
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(getCourseTemplatesEnd());
    }
  };
